
let checkPlugin = {};



//表单校验
checkPlugin.install = function (Vue, options) {

    // 注册一个全局自定义指令 `v-check` 进行表单校验
    Vue.directive('check', {
        bind: function(el, binding) {
            el.needCheck = true;
        },
        update: function(el, binding) {
            let msg = Object.keys(binding.value).find(key => binding.value[key])
            if (msg) {
                el.checkResult = msg;
            } else {
                el.checkResult = null;
            }
        }
    })

    /**
     * 检测form表单
     * @param form
     * @returns {Promise<unknown>}
     */
    Vue.prototype.$checkForm = function(form) {

        return new Promise(resolve => {


            let children = form.$children;

            var checks = children.filter(item => {
                return item.$options && item.$options._componentTag == "el-form-item" && item.$el.needCheck;

            }).map(item => this.$checkFormItem(item));


            Promise.all(checks).then(results => {
                let result = results.includes(false) == false; //结果里没有false
                resolve(result);
            })

        })
    }



    /**
     * 检测单个form表单项
     * @param form
     * @returns {Promise<unknown>}
     */
    Vue.prototype.$checkFormItem = function(formItem) {
        return new Promise(resolve => {
            let result = formItem.$el.checkResult;
            if (result == null) { //校验通过，无提示信息
                resolve(true);
                return;
            }
            this.$set(formItem.$props, "error", result);

            resolve(false);

        })
    }





}

export default checkPlugin;
